import { createDeferredI18n } from "#/shared/composables/useI18n";

import fallbackMessages from "#/shared/i18n/frontend.job_progress.json";

// A registered component has no app to install the vue-i18n plugin on, so `t` below reads
// `i18n.global` directly.
const { i18n, ready: whenI18nReady } = createDeferredI18n({ key: "job_progress", fallbackMessages });

export { whenI18nReady };

/**
 * Translates a job progress string. Keys are relative to `frontend.job_progress`, which the i18n
 * endpoint serves as the message root, and resolve per client through that client's own locale
 * files.
 *
 * @param {String} key
 * @param {Object} values - Values for the named placeholders of the message.
 * @param {Number} count - Chooses the singular or plural form of the message.
 * @returns {String}
 */
export function t(key, values, count) {
  return i18n.global.t(key, values, count);
}
